export const HeaderHeight = 48;
export const FlexPaneTitleHeight = 65;
